import type { IIndexHeader } from "~/utils/interfaces/table-interfaces";
import { ColorsTypeEnum } from "~/utils/enums/colores.enums";
import { EvaluationTypeEnum } from "~/utils/enums/evaluations.enums";
import { ACTIVITY_TYPE_META, QUIZ_TYPE_META, isQuizType } from "~/utils/helpers/quiz.helpers";
import { needsKind } from "~/utils/helpers/evaluation-templates.helpers";
import type { IActivityDraft } from "~/utils/interfaces/activities-interfaces";

export const EVALUATION_TYPE_LABEL: Record<EvaluationTypeEnum, string> = {
  [EvaluationTypeEnum.DIRECT]: "Enquête à chaud",
  [EvaluationTypeEnum.DELAYED]: "Enquête à froid",
  [EvaluationTypeEnum.QUESTIONNAIRE]: "Questionnaire",
};

// Tag color = design-system tokens only (never Figma hex).
export const EVALUATION_TYPE_TAG: Record<EvaluationTypeEnum, ColorsTypeEnum> = {
  [EvaluationTypeEnum.DIRECT]: ColorsTypeEnum.LIGHT_ORANGE,
  [EvaluationTypeEnum.DELAYED]: ColorsTypeEnum.LIGHT_BLUE,
  [EvaluationTypeEnum.QUESTIONNAIRE]: ColorsTypeEnum.LIGHT_PURPLE,
};

/**
 * Meta line under a block title, e.g. "Question système · Note 1 à 10 · Obligatoire". In a questionnaire a free
 * question says it is "Libre", since scored and free ones then sit side by side.
 */
export function getBlockMeta(activity: IActivityDraft, isQuestionnaire = false): string {
  if (needsKind(activity)) return "Sélectionnez un type";
  const { quiz } = activity;
  if (!quiz || !isQuizType(quiz.subType)) return activity.type ? ACTIVITY_TYPE_META[activity.type].label : "";
  const meta = QUIZ_TYPE_META[quiz.subType];
  const parts: string[] = [];
  if (quiz.isSystem) parts.push("Question système");
  if (isQuestionnaire && !meta.scored) parts.push("Libre");
  parts.push(meta.shortLabel ?? meta.label);
  parts.push(quiz.required ? "Obligatoire" : "Optionnelle");
  return parts.join(" · ");
}

/**
 * Column config for the Settings "Évaluations" list. Headers live here (not inline in the SFC)
 * per project convention. The table shows only "Nom" + "Type" (+ a trailing actions cell).
 */
export const useEvaluationTemplates = () => {
  const headers: IIndexHeader[] = [
    { name: "Nom", key: "name", sort: false, minWidthPx: 320, maxWidthFr: 3, visible: true },
    { name: "Type", key: "type", sort: false, minWidthPx: 200, maxWidthFr: 1, visible: true },
    { name: "", key: "actions", sort: false, minWidthPx: 64, maxWidthFr: 1, visible: true, align: "right" },
  ];

  return { headers };
};
